import { SIZES_V2 } from './V2/sizes';

export const SIZES = {
  HEADER_DESKTOP_HEIGHT: SIZES_V2.HEADER_SIZE,
  STATUSBAR_PORTRAIT_HEIGHT: 32,
  STATUSBAR_LANDSCAPE_HEIGHT: 20,
  APPBAR_PORTRAIT_HEIGHT: 48,
  APPBAR_LANDSCAPE_HEIGHT: 48,
  APPBAR_ITEM_SIZE: 42,
  FOOTER_MOBILE_HEIGHT: 40,
  FOOTER_DESKTOP_HEIGHT: 30,
  MOBILE_BET_TOOLBAR_SIZE: 48,
  MOBILE_LANDSCAPE_BET_TOOLBAR_SIZE: 62,
  PADDING: 10,
  MARGIN: 10,
  CHIP_SIZE: 40,
  MOBILE_BUTTON_SIZE: 40,
} as const;
